var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeriod01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.037px",
    height: "16.018px",
    viewBox: "78.597 140.117 16.037 16.018",
    enableBackground: "new 78.597 140.117 16.037 16.018",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M94.306,149.725v-7.132c0-0.819-0.661-1.486-1.473-1.486h-0.491v-0.99h-0.981v0.99h-9.818v-0.99h-0.981 v0.99H80.07c-0.812,0-1.473,0.667-1.473,1.486v11.89c0,0.819,0.661,1.486,1.473,1.486h8.346v-0.124 c0.489,0.176,1.007,0.289,1.555,0.289c2.571,0,4.664-2.111,4.664-4.706C94.634,150.826,94.511,150.255,94.306,149.725z  M79.58,142.594c0-0.273,0.221-0.495,0.49-0.495h0.491v0.991h0.981v-0.991h9.818v0.991h0.981v-0.991h0.491 c0.271,0,0.491,0.222,0.491,0.495v2.477H79.58V142.594z M80.07,154.978c-0.27,0-0.49-0.222-0.49-0.495v-8.422h13.745v2.112 c-0.849-0.891-2.036-1.451-3.354-1.451c-2.571,0-4.663,2.111-4.663,4.706c0,1.424,0.643,2.687,1.636,3.55H80.07z M89.97,155.144 c-2.029,0-3.682-1.666-3.682-3.716c0-2.049,1.652-3.716,3.682-3.716c1.495,0,2.778,0.907,3.354,2.201v0.111h0.05 c0.176,0.434,0.277,0.906,0.277,1.403C93.652,153.478,92,155.144,89.97,155.144z M90.378,148.043h-0.981v3.964h2.945v-0.991h-1.964 V148.043z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeriod01);
export default __webpack_public_path__ + "static/media/icon_period-01.fb5e60acc33bd9613e44b4f0eb229e79.svg";
export { ForwardRef as ReactComponent };